<template lang="html">
  <Container dark name="contacts">
    <div class="form-container">
      <b-row>
        <b-col class="contacts-col" lg="5">
          <!-- <form class="feedback" name="feedback">
            <div class="inputs">
              <input type="text" ref="name" placeholder="Имя" name="name">
              <input type="text" ref="surname" placeholder="Фамилия" name="surname">
              <input type="text" ref="company" placeholder="Компания" name="company">
              <input type="email" ref="email" placeholder="E-mail*" name="email">
              <div>
                <small>{{message}}</small>
              </div>
            </div>
            <Button @click.native="sendForm">
              <b-spinner v-if="loading" small variant="light" label="Text Centered" />
              <span v-else>Отправить</span>
            </Button>
          </form> -->
          <div class="feedback">
            <h1>109316, г. Москва, Волгоградский проспект, 42</h1>
            <!-- <h4>Резидент Особой Экономической Зоны <a href="https://technomoscow.ru/" target="_blank">«Технополис «Москва»</a></h4> -->
            <br>
            <a href="https://technomoscow.ru/" target="_blank">
              <img
                alt="Резидент Особой Экономической Зоны «Технополис «Москва»"
                width="500"
                src="../assets/img/rezident3.png"
                @click="goToHref('video')"
              />
            </a>
            <ul class="contacts-links">
              <li><a href="tel:+74956401472">+7(495)-640-14-72</a></li>
              <li><a href="mailto:office@axiox.io">office@axiox.io</a></li>
            </ul>
          </div>
        </b-col>
        <b-col class="contacts-col col-logo" md="12" lg="7">
          <div class="logo">
            <Logo />
          </div>
        </b-col>
      </b-row>
    </div>
  </Container>
</template>

<script>
import Container from '../components/Container.vue'
// import Button from '../components/Button.vue';
import Logo from '../components/Logo.vue';
import Email from '../smtp.js';

export default {
  components: {
    Logo, Container
  },
  data: () => ({
    message: '',
    loading: false
  }),
  methods: {
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    sendForm() {
      let feedbackForm = document.forms.feedback
      let formData = new FormData(feedbackForm);
      let data = {};
      formData.forEach((value,key) => {data[key] = value});

      if (this.validateEmail(data.email)) {
        console.log(Email);
        this.loading = true;
        Email.send({
          SecureToken : "ce9ef7e0-61ae-487f-97ef-ae2301d4d6c7",
          To : 'sekretar@ttechnika.ru',
          From : "axioxsite@ttechnika.ru",
          Subject : "Заявка с сайта axiox.io",
          Body : `
          E-mail: ${formData.get('email')}${formData.get('name') || formData.get('surname') ? `, Имя: ${formData.get('name')} ${formData.get('surname')}` : ""}${formData.get('company') ? ", Компания: "+formData.get('company') : ""}
          `
        }).then(
          message => {
            this.loading = false;
            if (message === 'OK') this.message = "Заявка успешно отправлена!"
            else console.error(message);
          }
        );
      } else {
        this.$refs.email.focus();
      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="css" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .form-container {
    margin: 0 10%;
    padding: 0;
    min-height: 100vh;
    position: relative;
  }
  .contacts-col {
    min-height: 100vh;
  }
  .row {
    width: 100%;
  }
  .contacts-links {
    font-size: 20px;
    list-style-type:none;
    padding: 3rem 0;
  }
  .contacts-links li{
    margin: 0;
    padding: 0.25rem 0;
  }
  h4 {
    color: #767676;
  }
  h4 a {
    /*text-decoration: underline;*/
    color: #767676;
  }
  a{
    color: white;
  }
  .col-logo {
    position: relative;
  }
  .feedback, .logo {
    position: absolute;
    bottom: 50%;
    width: 100%;
    -ms-transform: translateY(50%);
    transform: translateY(50%);
  }
</style>
